(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gb-archive-grid"] && !Shopify.designMode) return;
  try {
    
  const roots = document.querySelectorAll('[data-gb-catalog-filters]');
  roots.forEach((root) => {
    const section = root.closest('.gb-atelier');
    const search = root.querySelector('[data-gb-catalog-search]');
    const craft = root.querySelector('[data-gb-catalog-craft]');
    const sort = root.querySelector('[data-gb-catalog-sort]');
    const grid = section.querySelector('[data-gb-catalog-grid]');
    const empty = section.querySelector('[data-gb-catalog-empty]');
    const originalCards = Array.from(grid.querySelectorAll('[data-gb-catalog-card]'));
    const applyFilters = () => {
      const query = search.value.trim().toLowerCase();
      const craftValue = craft.value;
      let visible = originalCards.filter((card) => {
        const haystack = `${card.dataset.title} ${card.dataset.craft} ${card.dataset.finish} ${card.dataset.summary}`.toLowerCase();
        return (!query || haystack.includes(query)) && (craftValue === 'all' || card.dataset.craft === craftValue);
      });
      if (sort.value === 'title') {
        visible = visible.sort((left, right) => left.dataset.title.localeCompare(right.dataset.title));
      }
      if (sort.value === 'craft') {
        visible = visible.sort((left, right) => left.dataset.craft.localeCompare(right.dataset.craft));
      }
      originalCards.forEach((card) => {
        card.hidden = true;
      });
      visible.forEach((card) => {
        card.hidden = false;
        grid.appendChild(card);
      });
      empty.hidden = visible.length > 0;
    };
    [search, craft, sort].forEach((control) => {
      control.addEventListener('input', applyFilters);
      control.addEventListener('change', applyFilters);
    });
    applyFilters();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gb-progress-lookup"] && !Shopify.designMode) return;
  try {
    
  const lookupRoots = document.querySelectorAll('[data-gb-progress-lookup]');
  lookupRoots.forEach((root) => {
    const form = root.querySelector('[data-gb-progress-form]');
    const message = root.querySelector('[data-gb-progress-message]');
    const results = root.querySelector('[data-gb-progress-results]');
    const apiPath = root.dataset.gbProgressApi || '/apps/pen-progress/api/public/lookup';

    const escapeHtml = (value) => String(value || '')
      .replaceAll('&', '&amp;')
      .replaceAll('<', '&lt;')
      .replaceAll('>', '&gt;')
      .replaceAll('"', '&quot;')
      .replaceAll("'", '&#039;');

    const formatDate = (value) => {
      if (!value) return 'Not set';
      return new Intl.DateTimeFormat('en', { year: 'numeric', month: 'short', day: 'numeric' }).format(new Date(value));
    };

    const statusLabel = (status) => ({
      in_progress: 'In progress',
      paused: 'Paused',
      ready_to_ship: 'Ready to ship',
      shipped: 'Shipped',
      completed: 'Completed'
    }[status] || 'In progress');

    const stepLabel = (status) => ({
      pending: 'Upcoming',
      active: 'In progress',
      done: 'Completed',
      skipped: 'Skipped'
    }[status] || 'Upcoming');

    const renderStep = (step) => `
      <li class="gb-lookup-step ${escapeHtml(step.status)}">
        <span></span>
        <div>
          <strong>${escapeHtml(step.name)}</strong>
          <em>${escapeHtml(stepLabel(step.status))}</em>
          ${step.publicNote ? `<p>${escapeHtml(step.publicNote)}</p>` : ''}
          ${step.completedAt ? `<small>Completed ${formatDate(step.completedAt)}</small>` : ''}
        </div>
      </li>
    `;

    const renderImage = (image) => `
      <figure>
        <img src="${escapeHtml(image.url)}" alt="${escapeHtml(image.title || 'Pen progress photograph')}" loading="lazy">
        <figcaption>${escapeHtml(image.title || formatDate(image.uploadedAt))}</figcaption>
      </figure>
    `;

    const renderProject = (project) => `
      <article class="gb-lookup-card">
        <div class="gb-lookup-card-head">
          <div>
            <p class="gb-eyebrow">${escapeHtml(statusLabel(project.status))}</p>
            <h2>${escapeHtml(project.title)}</h2>
            ${project.orderNumber ? `<p class="gb-muted">Order ${escapeHtml(project.orderNumber)}</p>` : ''}
          </div>
          <div class="gb-progress-seal" style="--gb-progress: ${Number(project.progressPercent || 0)}" aria-label="Progress ${Number(project.progressPercent || 0)}%">
            <strong>${Number(project.progressPercent || 0)}</strong>
            <span>%</span>
          </div>
        </div>
        <div class="gb-progress-track" style="--gb-progress-width: ${Number(project.progressPercent || 0)}%"><span></span></div>
        <dl class="gb-lookup-details">
          <div><dt>Current stage</dt><dd>${escapeHtml(project.currentStepName || 'To be confirmed')}</dd></div>
          <div><dt>Estimated time</dt><dd>${escapeHtml(project.estimate)}</dd></div>
          <div><dt>Last updated</dt><dd>${formatDate(project.updatedAt)}</dd></div>
        </dl>
        ${project.publicNote ? `<p class="gb-lookup-note">${escapeHtml(project.publicNote)}</p>` : ''}
        <ol class="gb-lookup-timeline">${(project.steps || []).map(renderStep).join('')}</ol>
        ${(project.images || []).length ? `<div class="gb-lookup-gallery">${project.images.map(renderImage).join('')}</div>` : ''}
      </article>
    `;

    const renderCustomer = (customer) => {
      if (!customer.projects || !customer.projects.length) {
        results.innerHTML = `
          <article class="gb-lookup-card">
            <p class="gb-eyebrow">Private Dossier</p>
            <h2>${escapeHtml(customer.label || customer.code)}</h2>
            <p class="gb-muted">This code is active, but no pen projects are currently attached.</p>
          </article>
        `;
        return;
      }
      results.innerHTML = `
        <article class="gb-lookup-summary">
          <div>
            <p class="gb-eyebrow">Private Atelier Dossier</p>
            <h2>${escapeHtml(customer.label || 'Your pen projects')}</h2>
            <p>These are the workshop notes currently available for your projects.</p>
          </div>
          <span>${escapeHtml(customer.code)}</span>
        </article>
        <div class="gb-lookup-grid">${customer.projects.map(renderProject).join('')}</div>
      `;
    };

    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      message.textContent = 'Opening your atelier dossier...';
      results.innerHTML = '';
      try {
        const response = await fetch(apiPath, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ code: new FormData(form).get('code') })
        });
        const payload = await response.json();
        if (!response.ok) throw new Error(payload.error || 'We could not find a matching progress page. Please check your code and try again.');
        message.textContent = '';
        renderCustomer(payload.customer);
      } catch (error) {
        message.textContent = error.message;
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
